<template>
    <div
        v-if="show"
        class="login-modal"
    >
        <header class="flex">
            <h1>{{ title }}</h1>
            <span v-if="des">{{ des }}</span>
        </header>
        <div class="content">
            <slot
                name="content"
            />
        </div>
        <footer>
            <slot
                name="foot"
            />
        </footer>
    </div>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            default:'设置密码'
        },
        des:{
            type:String,
            default:''
        }
    },
    data(){
        return {
            show:true
        }
    }
}
</script>

<style lang="scss" scoped>
    .login-modal{
        position: absolute;
        left: 50%;
        margin-left: -272px;
        margin-top: -187px;
        top: 50%;
        background: #fff;
        z-index: 2;
        width: 554px;
        height: 374px;
        h1{
            font-size:18px;
            font-family: "PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
            font-weight:600;
            color:rgba(32,44,85,1);
            line-height:25px;
            margin-top: 20px;
            padding-left: 20px;
        }
        header span {
            height:20px;
            font-size:14px;
            font-family: "PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
            font-weight:400;
            color:rgba(130,137,164,1);
            line-height:20px;
            margin-left: 15px;
            margin-top: 23px;
        }
        footer{
            position: absolute;
            bottom: 0;
            left: 0;
            height: 60px;
            width: 100%;
        }
        .content{
            padding-bottom: 60px;
        }
    }
</style>